import { IFeatureToggles, FeatureToggleName } from '../featureToggles.types';

/**
 * These are default hard-coded Production toggles.
 * These are fallback values in case any specific Feature Toggle has not been
 * added to the BE list of Feature Toggles through the Dexter app.
 *
 * This is the file used for production, edit with caution!
 * Recommend using lower-env configs for dev & testing as they will extend from this one.
 *
 * Note:
 * The business logic to use different feature toggle strategies depending on the different categories (Release,
 * Operations, Experimental) has been moved to the BE. FE will now only receive a list of Toggle names and
 * corresponding boolean values from the getUserFeatureToggles endpoint which will override the setting in this file.
 *
 * For more info, see https://chalk.charter.com/display/ERSPM/FE+Configs
 */
export const featureTogglesDefault: IFeatureToggles = {
  environment: 'default',
  toggles: [
    {
      name: FeatureToggleName.SSOPortalLinks,
      isEnabled: true,
    },

    {
      name: FeatureToggleName.SSOPortalLinksOrgTable,
      isEnabled: false,
    },

    {
      name: FeatureToggleName.AnalyticsQuantum,
      isEnabled: false,
    },

    {
      name: FeatureToggleName.PrefetchData,
      isEnabled: false,
    },
    {
      name: FeatureToggleName.TVP,
      isEnabled: true,
    },

    { name: FeatureToggleName.DataDogRumIntegration, isEnabled: true },
    { name: FeatureToggleName.UserVDSManagement, isEnabled: true },
    { name: FeatureToggleName.PendingUsers, isEnabled: true },
    { name: FeatureToggleName.BanNotificationSetting, isEnabled: true },
    // New PAM Ops Center "Add New Customer User" flow. Enabled in every
    // environment; lower envs can still flip it off via sessionStorage.
    // ENTDEL-29414.
    { name: FeatureToggleName.PAM, isEnabled: true },
    { name: FeatureToggleName.OrgDetailsProgressiveDelivery, isEnabled: true },
  ],
};
